var render = function render(){var _vm=this,_c=_vm._self._c;return _c('feedback-table',{attrs:{"kind":"idea","title":"Employee Feedback"}})
}
var staticRenderFns = []

export { render, staticRenderFns }